module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow-em-cd3d5aeb1b13762520a9460805fd61c4.svg";